import {ValueObject} from '@s-ui/domain'

export class SellerTradeDataTransactionsValueObject extends ValueObject {
  /**
   * @param {Object} data
   * @param {String} data.address
   * @param {String} data.bankAccount
   * @param {String} data.city
   * @param {String} data.email
   * @param {String} data.name
   * @param {String} data.lastName
   * @param {String} data.personalId
   * @param {String} data.phone
   * @param {String} data.zipCode
   */

  static create = ({address, bankAccount, city, email, lastName, name, personalId, phone, zipCode}) => {
    return new SellerTradeDataTransactionsValueObject({
      address,
      bankAccount,
      city,
      email,
      lastName,
      name,
      personalId,
      phone,
      zipCode
    })
  }
}
